export type RootLoaderData = Record<string, never>

export const loader = async () => {
  return {}
}
